import app, { Component } from 'apprun';
import { isValidElement, showSaveStatusMessage, lookup_en, isStringEqual } from '../utils';
import { commProg } from '../api';
import moment from 'moment';
export default class CommonPropertyComponent extends Component {
  dateFmt = 'DD-MMM-YYYY';

  state = { progs: [], exceptions: [], commFee: [] };

  cleanState = {
    commProgStartDatePicker: null,
    commProgEndDatePicker: null,
    exStartDatePicker: null,
    exEndDatePicker: null,
    editingItem: null,
    newCommProg: null,
    exceptions: [],
    showEx: null,
    editingEx: null,
    newEx: null,
    exUnderEdit: null,
    commProgSaveError: null,
    feeExSaveError: null,
    commFee: [],
    dateFmt:'DD-MMM-YYYY'
  };

  Item = ({ item, editingProgId }) => {
    return (
      <tr
        style={{ display: 'table-row' }}
        onclick={
          !item.locked
            ? (e) => {
              this.run('commProg-edit', item, e);
            }
            : ''
        }>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.id}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.active ? 'Active' : 'Inactive'}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : ''}
          </span>
        </td>

        <td span class="form-text" style={{ 'max-width': '200px' }}>{item.modifiedDate ? moment.utc(item.modifiedDate).format(this.dateFmt) : ''}</td>
        <td span class="form-text" style={{ 'max-width': '200px' }}>{item.auditModifiedUser}</td>
        <td>
          <div class="col-sm-2 text-right">
            {item.locked ? <i class="fa fa-lock" /> : ''}
            {item.id === editingProgId ? <i class="control-label glyphicon glyphicon-pencil" /> : ''}
          </div>
        </td>
      </tr>
    );
  };

  List = ({ state }) => {
    return (
      <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
        <thead>
          <tr>
            <th>Id</th>
            <th>Status</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Modified Date</th>
            <th>Modified User</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {state.progs.map(item => (
            <this.Item item={item} editingProgId={state.editingProgId} />
          ))}
        </tbody>
      </table>
    );
  };

  CommProgHistory = ({ state }) => {
    return (
      <div>
        <div class="col-sm-12">Commercial Program History</div>
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.List state={state} />
        </div>
      </div>
    );
  };

  CommProgEdit = ({ state }) => {
    return (
      <div style={{ display: state.editingProg ? 'disp' : 'none' }}>
        <div class="row" style={{ display: state.newCommProg ? 'disp' : 'none' }}>
          **NEW**
        </div>
        <div>
          { (state.validate)
            ?<span style={{ color:'green' }}>
              <label>Possible Range:&nbsp;</label>
              {state.minDate.format(state.dateFmt) + ' - ' +  state.maxDate.format(state.dateFmt)}
              <br/>
            </span>
            :<span  class="text-danger">
              * Data inconsistency detected, cannot suggest possible range.<br/>
              * WARNING: validation will not be performned on save
              <br/>
            </span>

          }
        </div>
        <div class="row">
          <label class="col-sm-5">Start Date</label>
          <label class="col-sm-5">End Date</label>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="commProgStartDate" size="62" class="form-control" value={state.commProgStartDate} />
          </div>
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="commProgEndDate" size="62" class="form-control" value={state.commProgEndDate} />
          </div>
        </div>
        <div class="row">
          <div id="commProgStartDateErrMsg" class="text-danger, col-sm-5"></div>
          <div id="commProgEndDateErrMsg" class="text-danger, col-sm-5"></div>
          <div id="commProgReturnedErrMsg" class="text-danger, col-sm-5">
            {state.commProgSaveError}
          </div>
        </div>
        <br></br>
        <div class="row">
          <label class="col-sm-5">Amount</label>
          <div class="col-sm-5">
            <this.ddlComp
              id="commercialProgFeeID"
              // optoins={lookup_en.CommercialFeeCt}
              optoins={state.commFee}
              objWithRetAttrib={state.progUnderEdit}
              retAttrib="commercialFeeID"
            />
          </div>
        </div>

        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('commProg-edit-save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('commProg-edit-cancel')}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  ddlComp = ({ id, optoins, objWithRetAttrib, retAttrib }) => {
    return (
      <div>
        <select id={id} class="form-control" oninput={e => (objWithRetAttrib[retAttrib] = e.target.value)}>
          <option value="-1">[Select]</option>
          {optoins.map(p => (
            <option
              value={p.id}
              selected={isStringEqual(p.id, objWithRetAttrib?.[retAttrib])?'selected':''}>
              {p.value}
            </option>
          ))}
        </select>
        <div id={id + 'ErrMsg'} class="text-danger, row"></div>
      </div>
    );
  };

  FeeExEdit = ({ state }) => {
    return (
      <div style={{ display: state.editingEx ? 'disp' : 'none' }}>
        <div class="col-sm-12">Commercial Program Fee Exception Edit</div>
        <div class="row">
          <label class="col-sm-5">Exception Type</label>
          <div class="col-sm-5">
            <this.ddlComp
              id="exType"
              optoins={lookup_en.FeeExceptionReasonCt}
              objWithRetAttrib={state.exUnderEdit}
              retAttrib="exceptionType"
            />
          </div>
        </div>
        <br />
        <div class="row">
          <label class="col-sm-5">Start Date</label>
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="exStartDate" size="62" class="form-control" value={state.FeeExStartDate} />
            <div id="exStartDateErrMsg" class="text-danger, row"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <label class="col-sm-5">End Date</label>
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="exEndDate" size="62" class="form-control" value={state.FeeExEndDate} />
            <div id="exEndDateErrMsg" class="text-danger, row"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <label class="col-sm-5">Amount</label>
          <div class="col-sm-5">
            <this.ddlComp
              id="Amount"
              optoins={state.commFee}
              objWithRetAttrib={state.exUnderEdit}
              retAttrib="commercialFeeID"
            />
          </div>
        </div>
        <div class="row">
          <div id="feeExReturnedErrMsg" class="text-danger, col-sm-10">
            {state.feeExSaveError}
          </div>
        </div>

        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('feeEx-edit-save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('feeEx-edit-cancel')}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  ItemEx = ({ item, editing, commFee }) => {
    return (
      <tr
        style={{ display: 'table-row' }}
        onclick={
          !item.locked
            ? (e) => {
              this.run('feeEx-edit', item, e);
            }
            : ''
        }>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.commercialCompanyPersonID}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {this.getExTypeById(item.exceptionType)}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {this.getCommFeeById(commFee, item.commercialFeeID)}
          </span>
        </td>
        <td span class="form-text" style={{ 'max-width': '200px' }}>{item.modifiedDate ? moment.utc(item.modifiedDate).format(this.dateFmt) : ''}</td>
        <td span class="form-text" style={{ 'max-width': '200px' }}>{item.auditModifiedUser}</td>

        <td>
          <div class="col-sm-2 text-right">
            {editing ? <i class="control-label glyphicon glyphicon-pencil" /> : ''}
          </div>
        </td>
      </tr>
    );
  };

  ListEx = ({ state }) => {
    return (
      <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
        <thead>
          <tr>
            <th>Prog Id</th>
            <th>Exception Type</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Amount</th>
            <th>Modified Date</th>
            <th>Modified User</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {state.exceptions.map(item => (
            <this.ItemEx item={item} editing={state.editingEx && state.exUnderEdit.id === item.id} commFee={state.commFee} />
          ))}
        </tbody>
      </table>
    );
  };

  CommProgFeeEx = ({ state }) => {
    return (
      <div style={{ display: state.showEx ? 'disp' : 'none' }}>
        <div class="col-sm-12">Commercial Program Fee Exceptions</div>
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.ListEx state={state} />
        </div>
        <div>
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('feeEx-new', e)}>
            New Exception
          </a>
        </div>
      </div>
    );
  };

  // prettier-ignore
  view = (state) => {
    return (
      <div style={{ width: '550px' }}>
        <this.CommProgHistory state={state} />
        <div>
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('commProg-new', e)}>
            Add New Commercial Program
          </a>
        </div>
        <br/>
        <this.CommProgEdit state={state} />
        <br/><br/>
        <this.CommProgFeeEx state={state} />
        <br/><br/>
        <this.FeeExEdit state={state} />
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      this.cleanState.commFee = await commProg.getCommFee();
      if (newState.panelId !== state.personId) {
        state = this.cleanState;
        state.personId = newState.personId;
        state.companyPersonId = newState.extra.CompanyPersonID;
      }
      state.progs = await commProg.get(state.personId);
      state.showEx = true;
      state.exceptions = await commProg.getExHistory(state.personId);
      return { ...state, ...newState };
    },

    'showEx-toggle': async (state) => {
      state.showEx = !state.showEx;
      if (state.showEx) {
        state.exceptions = await commProg.getExHistory(state.personId);
      } else {
        state.editingEx = false;
        state.exUnderEdit = null;
        state.editingExId = null;
      }

      return state;
    },

    'commProg-new': (state, e) => {
      this.run('commProg-edit', { id: 0, commercialFeeID: 1 }, e);
    },

    'commProg-edit': async (state, item) => {
      if (state.editingProg) {return;}

      const result = await commProg.getCommConstraints(state.companyPersonId);
      if(result?.status === 'OK') {
        state.validate = true;
        state.minDate = moment(result.minPossibleStartDateforCommProg);
        state.maxDate = moment(result.maxPossibleEndDateforCommProg);
      } else {
        state.validate = false;
        state.minDate = state.maxDate = null;
      }

      state.commProgStartDate = item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : '';
      state.commProgEndDate = item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : '';
      state.commercialProgFeeID = item.commercialFeeID;

      state.newCommProg = item.id === 0;

      state.editingProg = true;
      state.editingProgId = item.id;
      state.progUnderEdit = item;
      return state;
    },

    'commProg-edit-save': async (state) => {
      state.commProgSaveError = null;
      const commProgReturnedErrMsgDiv = document.getElementById('commProgReturnedErrMsg') as HTMLDivElement;
      commProgReturnedErrMsgDiv.innerHTML = state.commProgSaveError;

      state.commProgStartDate = (document.getElementById('commProgStartDate') as HTMLInputElement).value.trim();
      state.commProgEndDate = (document.getElementById('commProgEndDate') as HTMLInputElement).value.trim();

      state.commercialProgFeeID = (document.getElementById('commercialProgFeeID') as HTMLInputElement).value.trim();

      let valid = isValidElement('commProgStartDate', 'DateStr');
      if (state.commProgEndDate) {
        valid = valid && isValidElement('commProgEndDate', 'DateStr');
        if (valid && moment(state.commProgStartDate, this.dateFmt) > moment(state.commProgEndDate, this.dateFmt)) {
          valid = false;
          const errMsg = document.getElementById('commProgEndDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = 'End date cannot be before Start date';
        }
        if (valid && (
          moment(state.commProgStartDate, this.dateFmt) < moment(state.minDate, this.dateFmt)
          || moment(state.commProgEndDate, this.dateFmt) > moment(state.maxDate, this.dateFmt)
        )
        ) {
          valid = false;
          const errMsg = document.getElementById('commProgStartDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* dates should be between possible range';
        }
      } else {
        const endDate = new Date(9999, 1, 1);
        if (valid && (
          moment(state.commProgStartDate, this.dateFmt) < moment(state.minDate, this.dateFmt)
          || moment(endDate, this.dateFmt) > moment(state.maxDate, this.dateFmt)
        )
        ) {
          valid = false;
          const errMsg = document.getElementById('commProgStartDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* dates should be between possible range';
        }
      }

      if (state.commercialProgFeeID === '-1') {
        valid = false;
        const errMsg = document.getElementById('commercialProgFeeIDErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'Please select fee amount';
      }

      if (valid) {
        const progToSave =
          state.editingProgId === 0
            ? { id: 0, commercialFeeID: state.commercialProgFeeID, startDate: state.commProgStartDate, endDate: state.commProgEndDate }
            : { ...state.progUnderEdit, startDate: state.commProgStartDate, endDate: state.commProgEndDate };
        let result;
        try {
          result = await commProg.upsertCommProg(state.personId, progToSave);
          showSaveStatusMessage(result);
        } catch (ex) {
          showSaveStatusMessage();
          const errorMsg = await ex.json();
          state.commProgSaveError = '* ' + errorMsg;
          return state;
        }

        if (result) {
          state.progs = await commProg.get(state.personId);
          this.run('commProg-edit-cancel');
        }
      }
    },

    'commProg-edit-cancel': (state) => {
      state.editingProg = false;
      state.progUnderEdit = null;
      state.editingProgId = null;
      return state;
    },

    'feeEx-new': (state, e) => {
      this.run('feeEx-edit', { id: 0 }, e);
    },

    'feeEx-edit': (state, item) => {
      if (state.editingEx) {return;}

      state.exUnderEdit = { ...item };
      state.FeeExStartDate = item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : '';
      state.FeeExEndDate = item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : '';
      state.newEx = item.id === 0;

      state.editingEx = true;
      return state;
    },

    'feeEx-edit-cancel': (state) => {
      state.editingEx = false;
      state.exUnderEdit = null;
      state.editingExId = null;
      return state;
    },

    'feeEx-edit-save': async (state) => {
      state.feeExSaveError = null;
      const feeExReturnedErrMsgDiv = document.getElementById('feeExReturnedErrMsg') as HTMLDivElement;
      feeExReturnedErrMsgDiv.innerHTML = state.feeExSaveError;

      state.FeeExStartDate = (document.getElementById('exStartDate') as HTMLInputElement).value.trim();
      state.FeeExEndDate = (document.getElementById('exEndDate') as HTMLInputElement).value.trim();

      let valid = isValidElement('exStartDate', 'DateStr');
      valid = isValidElement('exType', 'Int-1') && valid;
      valid = isValidElement('Amount', 'Int-1') && valid;

      if (state.FeeExEndDate) {
        valid = valid && isValidElement('exEndDate', 'DateStr');
        if (valid && moment(state.FeeExStartDate, this.dateFmt) > moment(state.FeeExEndDate, this.dateFmt)) {
          valid = false;
          const errMsg = document.getElementById('exEndDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = 'End date cannot be before Start date';
        }
      }

      if (valid) {
        state.exUnderEdit = { ...state.exUnderEdit, startDate: state.FeeExStartDate, endDate: state.FeeExEndDate };

        let result;
        try {
          result = await commProg.upsertCommFeeEx(state.personId, state.exUnderEdit);
        } catch (ex) {
          const errorMsg = await ex.json();
          state.feeExSaveError = '* ' + errorMsg;
          return state;
        }
        showSaveStatusMessage(result);
        if (result) {
          state.exceptions = await commProg.getExHistory(state.personId);
          this.run('feeEx-edit-cancel');
        }
      }
    }
  };

  getCommFeeById = (commFee, id) => {
    const selected = commFee.find(p => p.id === id);
    return selected.value;
  };

  getExTypeById = (id) => {
    const selected = lookup_en.FeeExceptionReasonCt.find(p => p.id === id);
    return selected.value;
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
